export enum SubscriptionKind {
	Gift = "Gift",
	Recurring = "Recurring",
}
